/**
 * Модуль инициализации ссылок в header.
 */
itsoftApp.createModule('headerLinks', function () {
  // Локальные переменные
  let module = this;

  const headerLinks = function () {
    const menuItems = document.querySelectorAll('.main-menu__item');
    const currentClassName = 'main-menu__item--current';

    document.addEventListener('click', (event) => {
      const target = event.target;

      // Если клик на ссылку и если она содержит определенные классы
      if (target.classList.contains('js-main-menu-link') &&
        !target.closest('.main-menu__item').classList.contains(currentClassName)) {

        menuItems.forEach(item => item.classList.remove(currentClassName));
        target.closest('.main-menu__item').classList.add(currentClassName);

        // Если клик на SVG внутри ссылки, то ищем классы у ссылки и пункта меню выше, то сначала проверка
      } else if (target.closest('.js-main-menu-link')) {

        // Потом проверка на наличие класса. Если клик повторные, то блок else
        if (target.closest('.js-main-menu-link').classList.contains('js-main-menu-link') &&
          !target.closest('.main-menu__item').classList.contains(currentClassName)) {

          menuItems.forEach(item => item.classList.remove(currentClassName));
          target.closest('.main-menu__item').classList.add(currentClassName);
        } else {
          menuItems.forEach(item => item.classList.remove(currentClassName));
        }
      } else {
        menuItems.forEach(item => item.classList.remove(currentClassName));
      }
    });

    window.addEventListener('scroll', event => {
      const target = document.querySelector(`.${currentClassName}`);

      if (target) {
        target.classList.remove(currentClassName)
      }
    })
  };

  headerLinks();
  module.callback = headerLinks;
});
